type UnauthorizedHandler = () => void | Promise<void>;

let handler: UnauthorizedHandler | null = null;
let isHandling = false;

/**
 * Register a callback invoked when any Feathers API request returns 401.
 * AuthProvider sets this to clear the local session.
 */
export function setUnauthorizedHandler(next: UnauthorizedHandler | null): void {
    handler = next;
}

/**
 * Notify that the session is no longer valid (API returned 401).
 * Safe to call multiple times; concurrent/re-entrant calls are ignored.
 */
export function notifyUnauthorized(): void {
    if (isHandling || !handler) {
        return;
    }

    isHandling = true;
    Promise.resolve(handler())
        .catch(() => {
            // Sign-out must not throw into API callers.
        })
        .finally(() => {
            isHandling = false;
        });
}
